export default __webpack_public_path__ + "static/media/premium4.fcfaea83.webp";